import { format } from "date-fns";
import { TableWidgetRow } from "@hatch-digital-nl/abs-storybook/legacy";
import { CertificateInterface } from "../../../common/interfaces/CertificateInterface";

interface Args {
    certificates: CertificateInterface[];
}

export const mapExpiringSoonCertificatesToRows = (
    args: Args,
): TableWidgetRow[] => {
    return args.certificates.map((certificate) => {
        return [
            {
                value: certificate.qualification.name,
            },
            {
                value: certificate.expires_at
                    ? format(certificate.expires_at, "dd-MM-yyyy")
                    : "",
            },
        ];
    });
};
